'use strict';

var $ = require('jquery');

/*@ngInject*/
module.exports = function($scope,  $anchorScroll, $state, $stateParams, $window, $translate, $http, $location, platform, $rootScope) {

	var slide = $stateParams.videoId;
	var len = 6;
	var step = 3;
	var size = 3;

	$scope.currentLanguage = $translate.use();
	$rootScope.copyButton = "Copy";
	//$scope.showbuy = navigator.language || navigator.userLanguage;
	var activationCode = $rootScope.searchData;
	if(activationCode)
	{
		var url = $location.protocol() + '://' + $location.host() + '/encrypt/' + activationCode;
		console.log("Url  : ",url)
		$http({
			method: 'GET',
			url: url
		}).then(function(response) {  // this callback will be called asynchronously when the response is available
			activationCode = response.data.encrypted_activation_code;
			console.log("Encrypted activation code :", activationCode);
			IntelSecurity.Analytics.Api.Track
            	.event('silent_activation_encryption_success')
            	.feature('Lifecycle')
            	.category('Onboarding')
            	.action('Silent Activation')
            	.label('Activation Code Encrypted')
            	.interactive(true)
            	.userInitiated(true)
            	.finish();
		},function(response) {         // called asynchronously if an error occurs or server returns response with an error status.
			console.log("Error while calling encryption API : ", response.data);
			IntelSecurity.Analytics.Api.Track
            	.event('silent_activation_encryption_failure')
            	.feature('Lifecycle')
            	.category('Onboarding')
            	.action('Silent Activation')
            	.label('Activation Code Encryption Failed')
            	.interactive(true)
            	.userInitiated(true)
            	.finish();
		});
	}

	$scope.allslides = [
						{
							"name": "getstart",
							"img" : "Thumbnail_GettingStarted.jpg",
							"ref": "getstart"
						},
						{
							"name": "activity",
							"img": "Thumbnail_ActivityFeed.jpg",
							"ref": "featureactivity"
						},
						{
							"name" : "permission",
							"img" : "Thumbnail_Permissions.jpg",
							"ref": "featurepermission"
						},
						{
							"name" : "map",
							"img" : "Thumbnail_FamilyMap.jpg",
							"ref": "featuremap"
						},
						{
							"name" : "rules",
							"img": "Thumbnail_Rules.jpg",
							"ref": "featurerules"
						},
						{
							"name": "ios",
							"img" : "Thumbnail_iOSSupport.jpg",
							"ref": "featureios"
						},
						{
							"name": "getstart",
							"img" : "Thumbnail_GettingStarted.jpg",
							"ref" : "getstart"

						},
						{
							"name": "activity",
							"img": "Thumbnail_ActivityFeed.jpg",
							"ref": "featureactivity"
						}

		];

	if (slide === '2') // it is activity
	{
		$scope.slides = [
						{
							"name" : "rules",
							"img": "Thumbnail_Rules.jpg",
							"ref": "featurerules"
						},

						{
							"name" : "map",
							"img" : "Thumbnail_FamilyMap.jpg",
							"ref": "featuremap"
						},
						{
							"name" : "permission",
							"img" : "Thumbnail_Permissions.jpg",
							"ref": "featurepermission"
						}
						
		];
	} else if (slide === '4' )
	{
		$scope.slides = [
						{
							"name" : "permission",
							"img" : "Thumbnail_Permissions.jpg",
							"ref": "featurepermission"
						},
						{
							"name": "ios",
							"img" : "Thumbnail_iOSSupport.jpg",
							"ref": "featureios"
						},
						{
							"name": "getstart",
							"img" : "Thumbnail_GettingStarted.jpg",
							"ref" : "getstart"

						}
						
						
		];
	} else if (slide === '5') {
		$scope.slides = [
						{
							"name" : "map",
							"img" : "Thumbnail_FamilyMap.jpg",
							"ref": "featuremap"
						},
						{
							"name" : "permission",
							"img" : "Thumbnail_Permissions.jpg",
							"ref": "featurepermission"
						},
						{
							"name": "ios",
							"img" : "Thumbnail_iOSSupport.jpg",
							"ref": "featureios"
						}

		];

	} else if (slide === '3') {
		$scope.slides = [
						{
							"name": "ios",
							"img" : "Thumbnail_iOSSupport.jpg",
							"ref": "featureios"
						},
						{
							"name": "getstart",
							"img" : "Thumbnail_GettingStarted.jpg",
							"ref" : "getstart"
						},
						{
							"name": "activity",
							"img": "Thumbnail_ActivityFeed.jpg",
							"ref": "featureactivity"
						}
						
		];
	} else if (slide ==='0') 
	{
		$scope.slides = [
						{
							"name": "getstart",
							"img" : "Thumbnail_GettingStarted.jpg",
							"ref" : "getstart"
						},
						{
							"name": "activity",
							"img": "Thumbnail_ActivityFeed.jpg",
							"ref": "featureactivity"
						},
						{
							"name" : "rules",
							"img": "Thumbnail_Rules.jpg",
							"ref": "featurerules"
						}
						
		];

	} else if (slide === '1')
	{
		$scope.slides = [
				{
					"name": "activity",
					"img": "Thumbnail_ActivityFeed.jpg",
					"ref": "featureactivity"
				},
				{
					"name" : "rules",
					"img": "Thumbnail_Rules.jpg",
					"ref": "featurerules"
				},
				{
					"name" : "permission",
					"img" : "Thumbnail_Permissions.jpg",
					"ref": "featurepermission"
				}


						
		];

	}
	else
	{
	$scope.slides = $scope.allslides.slice(slide, Number(slide)+3);	
	}
	
	$scope.allvideos = $scope.allslides.slice(0, 6);
	

	$scope.prev = function() {
		
		slide = Number(slide - step);
		slide = slide % len;
		slide = slide >= 0 ? slide : Number(len + slide);
	
		$scope.slides = $scope.allslides.slice(slide, size + slide);
	};

	$scope.next = function() {
		slide = Number(slide + step);
		slide = slide % len;
		slide = slide >= 0 ? slide : Number(len + slide);
		
		$scope.slides = $scope.allslides.slice(slide, size + slide);
	};

	$scope.$on('$viewContentLoaded', function () {
		
    	window.scrollTo(0,0);
   	});	

	$scope.buynow = function($event, type) {
		/* This change shoudl be changed to support global Buy */
		var urlType = '.yearly';
		if(type && type !== ''){
            urlType = '.'+type;
		}

		window.open($translate.instant('out-going-links.ebizbuy'+urlType), '_self', 'location=yes');


	};

	$scope.buynowIos = function($event) {

		window.location.href = $scope.iosDownloadLink;


	};

	$scope.buynowAndroid = function($event) {
		window.location.href = $scope.androidDownloadLink;


	};


	$scope.downloadPopupBanner = true;

    $scope.redirectToDownload = function(){
        $location.path('/redirect');
    };

	$scope.toggleDownloadPopupBanner = function($event) {

		$scope.downloadPopupBanner = !$scope.downloadPopupBanner;

		if ($scope.downloadPopupBanner) {
			$scope.showDownloadPopupBanner($event);
		}

		$event.stopPropagation();
		return false;
	};

	$scope.showDownloadPopupBanner = function($event){
				
		$scope.downloadPopupBanner = true;
		var angular = require('angular');
		var winwidth = $window.innerWidth;
		var winheight = Number($window.innerHeight);
		var pagey = Number($event.pageY);
		var offsety = Number($event.offsetY);
		var clickparent = $event.target.parentNode;
		var rect = clickparent.getBoundingClientRect();

		var popwidth = 620;
		var popheight = 200;
		if (winwidth <= 480) {
			popheight = 340;
			popwidth = 250;
		}
				
		var left = Number(winwidth - popwidth) / 2;			
		var right = winwidth - rect.right;
				
		var top = pagey + offsety - popheight + (rect.bottom-rect.top);
		if (rect.top < popheight) {  
			top = pagey - offsety - 40;
		}
		top = top + 'px';
		right = right + 'px';
		left = left + 'px';
		$scope.topleft= {'right': right, 'top': top};	

		if (rect.left < Number(winwidth/2)) {
			$scope.topleft= {'left': left, 'top': top};	
		} else {
			$scope.topleft= {'right': right, 'top': top};
		}
		
	};


	$scope.closeDownloadPopupBanner = function() {		
		
		$scope.downloadPopupBanner = false;
	};


	$scope.downloadPopup = true;

	$scope.toggleDownloadPopup = function($event) {

		$scope.downloadPopup = !$scope.downloadPopup;

		if (!$scope.downloadPopup) {
			var angular = require('angular');
			var winwidth = $window.innerWidth;
			var winheight = Number($window.innerHeight);
			var pagey = Number($event.pageY);
			var offsety = Number($event.offsetY);
			var deltatop = 70;

			var popwidth = 620;
			var popheight = 220;

			if (winwidth <= 480) {
				popwidth = 250;
				popheight = 360;
				deltatop = 60;

			}

			var left = Number(winwidth -popwidth) / 2  + 'px';
			//var top = $event.pageY - $event.offsetY - 200 + 40 ;   
			var top = Number(pagey - offsety - popheight + deltatop) + 'px';

			var clickparent = $event.target.parentNode;
			
			var rect = clickparent.getBoundingClientRect();
			
			var right = Number(winwidth - rect.right ) + 'px';

			if (rect.left > Number(winwidth / 2 ) && rect.left > 620) {
				$scope.topleft= {'right': right, 'top': top};
			} else {
				$scope.topleft= {'left': left, 'top': top};	
			}

		}

		$event.stopPropagation();
		return false;
	};


	$scope.closeDownloadPopup = function() {
		
		$scope.downloadPopup = true;


	};

	$scope.playbtn = true;


	$scope.playanimation = function(aid) {
		var video = document.getElementById(aid);
		video.play();
	};


	$scope.map1 = true;
	$scope.map2 = true;
	$scope.map3 = true;

	$scope.play_animate = function(aid, playbtn) {
		var video = document.getElementById(aid);
		if (playbtn === 'map1') {
			$scope.map1 = false;
		} else if (playbtn === 'map2') {
			$scope.map2 = false;
		} else if (playbtn === 'map3') {
			$scope.map3 = false;
		}
		
		
		video.play();
	};

	// Function called on clicking the copy button 
	$scope.copyActivationCode = function (){
		$scope.platform = platform;
		var currentPlatform = $scope.platform.os.family.toLowerCase();
		if(activationCode){
			if(Clipboard.copyToClipBoard(activationCode, currentPlatform)){
				$rootScope.copyButton = "Copied";
				console.log("activation code copied");
				IntelSecurity.Analytics.Api.Track
            		.event('silent_activation_copy_success')
            		.feature('Lifecycle')
            		.category('Onboarding')
            		.action('Silent Activation')
            		.label('Activation Code copied')
            		.interactive(true)
            		.userInitiated(true)
            		.finish();
			}
			else{
				console.log("failed to copy");
				IntelSecurity.Analytics.Api.Track
            		.event('silent_activation_copy_failure')
            		.feature('Lifecycle')
            		.category('Onboarding')
            		.action('Silent Activation')
            		.label('Activation Code copy failed')
            		.interactive(true)
            		.userInitiated(true)
            		.finish();
			}
		}
	}
};

// Code to copy activation code in clipboard
window.Clipboard = (function(window, document) {
    var textArea;
    function createArea(text) {
        textArea = document.createElement('textArea');
        textArea.value = text;
        document.body.appendChild(textArea);
    }
    function selectValue(platform) {
		var range,selection;
		if(platform == 'ios'){
			range = document.createRange();
            range.selectNodeContents(textArea);
            selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
			textArea.setSelectionRange(0, 999999);
		}else{
			textArea.select();
		}
    }

    function copyValue() {       
        var success = document.execCommand('copy');
		document.body.removeChild(textArea);
		if(success){
			console.log("Success Copy command");
			return true;
		}else{
			return false;
		}
    }
    var copyToClipBoard = function(text, platform) {
        createArea(text);
        selectValue(platform);
        return copyValue();
    };
    return {
        copyToClipBoard: copyToClipBoard
    };
})(window, document);

